export enum AuthenticationTypes {
  AUTHENTICATION_REQUEST = '@refinanciamento/authentication/AUTHENTICATION_REQUEST',
  SET_CPF_AUTHENTICATION = '@refinanciamento/authentication/SET_CPF_AUTHENTICATION',
  SET_USERNAME_AUTHENTICATION = '@refinanciamento/authentication/SET_USERNAME_AUTHENTICATION',
}

export interface AuthenticationState {
  readonly cpfAuthentication?: string
  readonly userNameAuthentication?: string
}
